<template>
    <div class="w-full mx-auto relative" style="max-width: 1400px; min-height: calc(100vh - 80px);">
        <button class="mx-12 lg:mx-24 mt-8 md:mt-12 flex gap-2 items-center p-2 rounded-md bg-gray-300 
        ring-gray-300 hover:ring-2 ring-offset-2 duration-200 ring-offset-[#eeeeee]" @click="$router.push('/')">
            <svg class="size-5 mb-0.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                fill="currentColor" viewBox="0 0 24 24">
                <path fill-rule="evenodd"
                    d="M11.293 3.293a1 1 0 0 1 1.414 0l6 6 2 2a1 1 0 0 1-1.414 1.414L19 12.414V19a2 2 0 0 1-2 2h-3a1 1 0 0 1-1-1v-3h-2v3a1 1 0 0 1-1 1H7a2 2 0 0 1-2-2v-6.586l-.293.293a1 1 0 0 1-1.414-1.414l2-2 6-6Z"
                    clip-rule="evenodd" />
            </svg>
            <p class="text-sm mt-0.5 mr-1">Zurück zur Startseite</p>
        </button>
        <div class="flex flex-col md:flex-row pt-8 md:pt-12 pb-24">
            <div class="px-12 lg:px-24 text-left flex flex-col w-full md:w-[60%] gap-16 md:gap-24">
                <div>
                    <h1 class="font-written text-4xl">{{ news.Titel }}</h1>
                    <div class="flex gap-3 flex-wrap mt-3" v-if="news.Tag_des_Ereignisses">
                        <div class="flex gap-2 items-center mr-3">
                            <svg class="w-5 h-5 text-gray-500 mb-1" aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                viewBox="0 0 24 24">
                                <path fill-rule="evenodd"
                                    d="M5 5a1 1 0 0 0 1-1 1 1 0 1 1 2 0 1 1 0 0 0 1 1h1a1 1 0 0 0 1-1 1 1 0 1 1 2 0 1 1 0 0 0 1 1h1a1 1 0 0 0 1-1 1 1 0 1 1 2 0 1 1 0 0 0 1 1 2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a2 2 0 0 1 2-2ZM3 19v-7a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Zm6.01-6a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm2 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm6 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-10 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm6 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm2 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
                                    clip-rule="evenodd" />
                            </svg>
                            <p class="text-gray-500">{{ moment(news.Tag_des_Ereignisses).format(`DD. MMMM
                                YYYY`) }}
                            </p>
                        </div>
                        <!-- <div class="flex gap-2 items-center">
                            <svg class="w-5 h-5 text-gray-500 mb-1" aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                viewBox="0 0 24 24">
                                <path fill-rule="evenodd"
                                    d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-4a1 1 0 1 0-2 0v4a1 1 0 0 0 .293.707l3 3a1 1 0 0 0 1.414-1.414L13 11.586V8Z"
                                    clip-rule="evenodd" />
                            </svg>
                            <p class="text-gray-500">{{ moment(news.Tag_des_Ereignisses).format(`HH:mm`) }}
                            </p>
                        </div> -->
                    </div>
                    <div class="w-full h-[1px] bg-gray-300 rounded-full my-8"></div>
                    <div v-html="news.Inhalt" class="news_content"></div>
                </div>
            </div>
            <div class="text-left sticky mt-16 md:mt-0 flex-auto px-3 md:px-0 pr-3 md:pr-12 lg:pr-24 top-32 h-min">
                <div class="flex-auto md:w-auto flex flex-col items-center">
                    <div class="flex flex-col w-full" v-if="data?.length > 0">
                        <p class="text-md text-gray-500 px-1 mt-3 mb-3">Weitere Artikel</p>
                        <div class="flex flex-col gap-3 w-full">
                            <template v-for="i in data.slice(0, 3)" :key="i">
                                <div class="min-h-28 w-full bg-white rounded-md overflow-hidden flex select-none cursor-pointer group"
                                    style="box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);"
                                    @click="$router.push(`/artikel/${i.id}`)">
                                    <div>
                                        <img :src="`${CMS_URL}/assets/${i.Titelbild}`" class="h-full w-32 aspect-[1/1] object-cover"
                                            v-if="i.Titelbild">
                                        <div class="h-full w-32 aspect-[1/1] object-cover bg-gray-500 flex" v-if="!i.Titelbild">
                                            <svg class="size-10 text-white m-auto" aria-hidden="true"
                                                xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                fill="currentColor" viewBox="0 0 24 24">
                                                <path fill-rule="evenodd"
                                                    d="M5 5a1 1 0 0 0 1-1 1 1 0 1 1 2 0 1 1 0 0 0 1 1h1a1 1 0 0 0 1-1 1 1 0 1 1 2 0 1 1 0 0 0 1 1h1a1 1 0 0 0 1-1 1 1 0 1 1 2 0 1 1 0 0 0 1 1 2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a2 2 0 0 1 2-2ZM3 19v-7a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Zm6.01-6a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm2 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm6 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-10 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm6 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm2 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
                                                    clip-rule="evenodd" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div class="flex flex-col gap-2 p-3 flex-auto">
                                        <p class="line-clamp-2">{{ i.Titel }}</p>
                                        <div class="flex justify-between flex-wrap" v-if="i.Tag_des_Ereignisses">
                                            <div class="flex gap-2 items-center mr-3">
                                                <svg class="w-4 h-4 text-gray-500 mb-1" aria-hidden="true"
                                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                    fill="currentColor" viewBox="0 0 24 24">
                                                    <path fill-rule="evenodd"
                                                        d="M5 5a1 1 0 0 0 1-1 1 1 0 1 1 2 0 1 1 0 0 0 1 1h1a1 1 0 0 0 1-1 1 1 0 1 1 2 0 1 1 0 0 0 1 1h1a1 1 0 0 0 1-1 1 1 0 1 1 2 0 1 1 0 0 0 1 1 2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a2 2 0 0 1 2-2ZM3 19v-7a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Zm6.01-6a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm2 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm6 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-10 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm6 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm2 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
                                                        clip-rule="evenodd" />
                                                </svg>
                                                <p class="text-sm text-gray-500">
                                                    {{ moment(i.Tag_des_Ereignisses).format(`DD. MMMM YYYY`) }}
                                                </p>
                                            </div>
                                            <!-- <div class="flex gap-2 items-center">
                                                <svg class="w-4 h-4 text-gray-500 mb-1" aria-hidden="true"
                                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                    fill="currentColor" viewBox="0 0 24 24">
                                                    <path fill-rule="evenodd"
                                                        d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-4a1 1 0 1 0-2 0v4a1 1 0 0 0 .293.707l3 3a1 1 0 0 0 1.414-1.414L13 11.586V8Z"
                                                        clip-rule="evenodd" />
                                                </svg>
                                                <p class="text-sm text-gray-500">
                                                    {{ moment(i.Tag_des_Ereignisses).format(`HH:mm`) }}
                                                </p>
                                            </div> -->
                                        </div>
                                        <div class="flex gap-2 items-center group-hover:underline mt-auto ml-auto">
                                            <p class="text-sm">Artikel lesen</p>
                                            <svg class="w-5 h-5 mb-1" aria-hidden="true"
                                                xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                                viewBox="0 0 24 24">
                                                <path stroke="currentColor" stroke-linecap="round"
                                                    stroke-linejoin="round" stroke-width="2"
                                                    d="M19 12H5m14 0-4 4m4-4-4-4" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    data() {
        return {
            CMS_URL: process.env.VUE_APP_CMS_URL,
            news: {},
            data: [],
            moment
        }
    },
    watch: {
        "$route.params.id"() {
            this.id = this.$route.params.id;
            this.init();
        }
    },
    created() {
        this.init();
    },
    methods: {
        async init() {
            let rawData = await this.$userStore.getNews();
            let id = this.$route.params.id;
            this.data = rawData.filter(f => f.id != id);
            this.news = rawData.find(f => f.id == id);
        }
    }
}
</script>

<style lang="scss">
.news_content {
    img {
        max-width: 700px;
        width: 100%;
        margin: 30px 0;
    }

    p {
        margin: 12px 0;
    }
}
</style>